import React from "react";
import "react-chat-widget/lib/styles.css";

import PropTypes from "prop-types";

export const ChatOfflineMessage = ({ message, isOnline }) => {
  return (
    <div className="rcw-message offline-msg">
      <span className="rcw-timestamp">{!isOnline ? message : ""}</span>
    </div>
  );
};
ChatOfflineMessage.propTypes = {
  message: PropTypes.string.isRequired,
  isOnline: PropTypes.bool.isRequired,
};
